import { useMutation } from "react-query";
import { endpoints } from "utils/endpoints";
import http from "utils/http";

const addContact = (postData) => {
  return http().post(endpoints.forms.contact, postData);
};

export function useContact() {
  return useMutation(addContact, {
    onError: (errorData) => {
      const errorMessage = errorData?.error?.message || errorData?.message;
      alert(errorMessage);
    },
  });
}
